import { useCachedActions } from '@hooks/useCachedActions';
import type { FetchData } from '@hooks/useDataFetcher';
import { buildCacheKey } from '@shared/util/cache-utils';
import { useMemo } from 'react';
import type { IPartnersPartner } from 'types/custom';
import type { SnackbarActions } from './useSnackbar';

interface IActions {
  getPartnersByMarket: (market: string) => Promise<IPartnersPartner[]>;
}

export type UsePartners = (
  fetchData: FetchData,
  snackbar: SnackbarActions,
) => [{ loading: boolean }, IActions];

export const usePartners: UsePartners = (fetchData, snackbar) => {
  const { loading, createAction } = useCachedActions(snackbar);

  const actions = useMemo<IActions>(
    () => ({
      getPartnersByMarket: createAction(
        (market) => buildCacheKey('getPartnersByMarket', { market }),
        (market: string) =>
          fetchData<{ data: IPartnersPartner[] }>(
            `/api/partners-api/partners?market=${encodeURIComponent(market)}`,
          ).then((res) => res.data ?? []),
        [],
      ),
    }),
    [createAction, fetchData],
  );

  return [{ loading }, actions];
};
